import { Stack } from "@altimateai/lego";
import { getIconByDatastoreType } from "../DatastoreImage";
import styles from "../styles.module.scss";
import { TableDetailResponse } from "../types";

interface HeaderSectionProps {
  table: TableDetailResponse;
}

export const HeaderSection = ({ table }: HeaderSectionProps) => {
  const tableName = table.scope[table.scope.length - 1];
  return (
    <Stack align="center">
      {getIconByDatastoreType(table.datasource_type, "me-2 icon-md")}
      <div className={styles.column_table_name}>{tableName}</div>
    </Stack>
  );
};
